module.exports = __webpack_public_path__ + "static/media/usc.e5722f09.png";